import Select from "react-select";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// styles and images
import Close from "../../assets/close.svg";

// internal hooks
import { useEscape } from "../../hooks/useEscape";

// store
import { dbDataStore, messageAndErrorStore, userStore } from "../../store/Store";
import InputField from "../../formComponents/InputField";
import FormButton from "../../formComponents/FormButton";
import { useGetOptions } from "../../hooks/useGetOptions";

export default function AddUser({ setTrigger, users }) {
  // global state
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const currentUser = userStore((userDataStore) => userDataStore.currentUser);
  const currentCompany = userStore(
    (userDataStore) => userDataStore.currentCompany
  );
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const typesData = dbDataStore((dbData) => dbData.typesData);
  const setUsers = dbDataStore((dbData) => dbData.setUsers);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // state
  const [pending, setPending] = useState(false);
  const [rolesDD, setRolesDD] = useState();
  const [user, setUser] = useState({
    id: 0,
    email: "",
    role_id: 0,
    first_name: "",
    last_name: "",
    company_id: currentCompany.id,
    created_by_id: 0,
    updated_by_id: 0,
  });
  const navigate = useNavigate();

  useEscape(setTrigger, [], [], pending);

  const handleClose = () => {
    setTrigger(false);
  };

  const handleChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (option, e) => {
    setUser({
      ...user,
      [e.name]: option.value,
    });
  };

  useGetOptions(
    setRolesDD,
    typesData,
    "users_tbl",
    "role_id",
    "type_name",
    "Systems Admin"
  );

  const handleSubmit = (e) => {
    setPending(true);
    e.preventDefault();
    if (user.role_id === 0) {
      toggleNewMessage("Please fill out missing fields");
      setPending(false);
      return;
    }

    const requestBody = user;
    requestBody.created_by_id = currentUser.id;
    requestBody.updated_by_id = currentUser.id;
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);

    const requestOptions = {
      body: JSON.stringify(requestBody),
      method: "POST",
      headers: headers,
      signal: controller.signal,
    };
    fetch(`${process.env.REACT_APP_BACKEND}/lc/user/${user.id}`, requestOptions)
      .then((res) => {
        if (res.status === 401) {
          setAuthStatus(false);
          setPending(false);
          setTrigger(false);
          navigate("/login");
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (data.error) {
          if (data.message === "this email already exists") {
            toggleNewMessage(
              "This email already exists, please use a different email"
            );
            setPending(false);
            return;
          } else {
            toggleNewMessage("Something went wrong");
            setPending(false);
            return;
          }
        } else {
          toggleNewMessage(null, "User added");
          setTrigger(false);
          setPending(false);
          setUsers(data.data);
        }
      })
      .catch((err) => {
        toggleNewMessage("Something went wrong");
        setPending(false);
        return;
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };
  return (
    <div className="popup">
      <div className="popup-inner">
        {!pending && (
          <div className="close">
            <img onClick={handleClose} src={Close} alt="close" />
          </div>
        )}
        <h3>Add User</h3>
        <form onSubmit={handleSubmit}>
          <InputField
            name={"first_name"}
            title={"First Name"}
            type={"text"}
            className={"form-control"}
            value={user.first_name}
            onChange={handleChange}
            required={true}
          />
          <InputField
            name={"last_name"}
            title={"Last Name"}
            type={"text"}
            className={"form-control"}
            value={user.last_name}
            onChange={handleChange}
            required={true}
          />
          <InputField
            name={"email"}
            title={"Email"}
            type={"email"}
            className={"form-control"}
            value={user.email}
            onChange={handleChange}
            required={true}
          />
          <div className="mb-3">
            <label className="form-label">Role</label>
            <Select name="role_id" options={rolesDD} onChange={handleSelect} />
          </div>
          <FormButton pending={pending} name={"Add User"} />
        </form>
      </div>
    </div>
  );
}
